var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgCharityIconActive(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.255 12.737l-.973 1.024-7.325 7.765a1.491 1.491 0 01-1.082.474c-.406 0-.796-.17-1.083-.474L5.227 15.63l-1.75-1.85-.975-1.042a6.504 6.504 0 01-1.5-4.36c.045-1.603.667-3.127 1.74-4.26 1.072-1.134 2.514-1.792 4.03-1.839 1.516-.047 2.991.52 4.125 1.585l.969 1.028.98-1.028a5.906 5.906 0 012.116-1.456 5.634 5.634 0 012.497-.393 5.825 5.825 0 013.542 1.573 6.334 6.334 0 011.731 2.837 6.632 6.632 0 01.094 3.374 6.385 6.385 0 01-1.571 2.94z",
    fill: "#FF8C9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.248 3.985a4.56 4.56 0 00-3.308 1.45 5.098 5.098 0 00-1.372 3.497v.274c0 .31.117.609.325.829.208.22.49.343.784.343.294 0 .576-.123.784-.343.208-.22.325-.518.325-.829v-.274c.004-.685.264-1.34.722-1.825a2.401 2.401 0 011.726-.763c.295 0 .577-.123.785-.343.208-.22.324-.518.324-.83 0-.31-.116-.608-.324-.828A1.08 1.08 0 007.234 4l.014-.015z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.255 12.737l-.973 1.025-7.325 7.765a1.492 1.492 0 01-1.082.473c-.406 0-.796-.17-1.083-.473l-5.565-5.898c10.301 0 12.904-6.353 12.904-13.508a5.826 5.826 0 012.862 1.482 6.334 6.334 0 011.727 2.831 6.632 6.632 0 01.096 3.367 6.388 6.388 0 01-1.561 2.936z",
    fill: "#F26D83"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 2)",
    d: "M0 0h22v20H0z"
  })))));
}
export default SvgCharityIconActive;